module.exports = __webpack_public_path__ + "img/autospin_btn.7622caa5.png";